import { notification as o } from "./index51.mjs";
function f(r) {
  if (!Array.isArray(r == null ? void 0 : r.errors))
    return o.error(r.message), {};
  const s = {};
  return r.errors.map((a) => {
    s[a.property] = a.message;
  }), s;
}
export {
  f as mapErrors
};
